import { Component, HostListener, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { initFlowbite } from 'flowbite';
import { LanguageService } from '@services/language.service';
import { ActivatedRoute, ParamMap, Router, RoutesRecognized } from '@angular/router';
import { filter, take } from 'rxjs';
import { ErrorService } from '@services/error.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'remittance';
  isWebview = false;
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  private readonly errorService = inject(ErrorService);
  @HostListener('window:offline')
  handleOffline() {
    this.errorService.showError();
  }
  constructor(
    translate: TranslateService,
    private languageService: LanguageService
  ) {
    let lang = localStorage.getItem('lang') ?? '';
    const validLangRegex = /^(en|cn)$/;
    if (validLangRegex.test(lang)) {
      languageService.onSetLanguage(lang);
      return;
    }
    const browserLang = translate.getBrowserLang() ?? '';
    if (!validLangRegex.test(browserLang)) {
      languageService.onSetLanguage(browserLang);
      return;
    }
    languageService.onSetLanguage('cn');
  }
  private readonly updateStorageValues = (params: ParamMap) => {
    const token = params.get('access_token');
    const name = params.get('user.name');
    const id = params.get('user.id');
    const username = params.get('username');
    if (token) {
      localStorage.setItem('access_token', token);
    }
    if (name) {
      localStorage.setItem('user.name', name);
    }
    if (id) {
      localStorage.setItem('user.id', id);
    }
    if (username) {
      localStorage.setItem('username', username);
    }
    const version = params.get('app-version');
    const lang = params.get('lang');
    if (version) {
      localStorage.setItem('app-version', version);
    }
    if (lang) {
      localStorage.setItem('lang', lang);
      this.languageService.onSetLanguage(lang);
    }
  };
  ngOnInit() {
    initFlowbite();
    const userAgent = navigator.userAgent.toLowerCase();
    let safari = /safari/.test(userAgent);
    let ios = /iphone|ipod|ipad/.test(userAgent);
    if (userAgent.indexOf('wv') > -1 || userAgent.indexOf('webview') > -1 || (!safari && ios)) {
      this.isWebview = true;
    }
    this.route.queryParamMap.subscribe(params => {
      this.updateStorageValues(params);
    });
    this.router.events.pipe(filter(e => e instanceof RoutesRecognized)).subscribe(event => {
      this.updateStorageValues((event as RoutesRecognized).state.root.queryParamMap);
    });
    this.router.events
      .pipe(
        filter(e => e instanceof RoutesRecognized),
        take(1)
      )
      .subscribe(() => {
        if (window.initialLoadCompleted) {
          window.initialLoadCompleted.postMessage('');
        }
      });
  }
}

declare global {
  interface Window {
    requestBiometricMethod: {
      postMessage: (input: any) => void;
    };
    handleBiometricAuthResult: ((result: boolean) => void) | null;
    initialLoadCompleted: {
      postMessage: (input: any) => void;
    } | null;
  }
}
